/**
 * Renders a link that looks like a button
 */

import { ErrorAlert } from '@components/Alerts/ErrorAlert';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { useLogout } from '@hooks/customer/useLogout';
import React, { type ReactElement, useState } from 'react';

import { Button, type ButtonProps } from './Button';

export const LogoutButton = React.forwardRef<HTMLElement, ButtonProps>(
  ({ ...props }, forwardedRef): ReactElement => {
    const logout = useLogout();
    const [error, setError] = useState(false);

    const handleLogout = async () => {
      const succeeded = await logout();
      if (succeeded) {
        setError(false);
      } else {
        setError(true);
      }
    };

    return (
      <>
        <Button ref={forwardedRef} {...props} onClick={handleLogout} />
        <ErrorAlert show={error} setShow={setError}>
          <Paragraph>
            There was an issue logging you out. Please try again
          </Paragraph>
        </ErrorAlert>
      </>
    );
  }
);

LogoutButton.displayName = 'LogoutButton';
